import { render, staticRenderFns } from "./modalViewFile.vue?vue&type=template&id=2446824a&"
import script from "./modalViewFile.vue?vue&type=script&lang=js&"
export * from "./modalViewFile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports